import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { BzObjType } from '../Enums/BzObjType.enum';
import { EMode } from '../Enums/EMode.enum';

export class OciWebShopRequest<T extends EMode = EMode.entity> {
  /** Alias: id */
  id?: string;
  /** Alias: shadowBzObjectId */
  shadowBzObjectId?: string;
  /** Alias: bzObjMemberCode */
  bzObjMemberCode?: number;
  /** Alias: bzObjType */
  bzObjType?: BzObjType;
  /** Alias: userCode */
  userCode?: number;
  /** Alias: response */
  response?: string;
  /** Alias: state */
  state?: number;
  /** Alias: updateTime */
  updateTime?: string;
  /** Alias: insertTime */
  insertTime?: string;

  __typename?: string;
}

const fields: FieldDefinitions<OciWebShopRequest> = {
  id: {
    alias: 'id',
  },
  shadowBzObjectId: {
    alias: 'shadowBzObjectId',
  },
  bzObjMemberCode: {
    alias: 'bzObjMemberCode',
  },
  bzObjType: {
    alias: 'bzObjType',
  },
  userCode: {
    alias: 'userCode',
  },
  response: {
    alias: 'response',
  },
  state: {
    alias: 'state',
  },
  updateTime: {
    alias: 'updateTime',
  },
  insertTime: {
    alias: 'insertTime',
  },
  __typename: {
    alias: '__typename',
  },
};

export const ociWebShopRequestEntityDefinition: EntitiyDefinition<OciWebShopRequest> =
  {
    local: {},
    remote: {
      queryName: 'getOciWebshopRequestsCompleted',
      fragmentName: 'OciWebShopRequest',
      withPaginationWrapper: false,
      params: [
        { name: 'shadowBzObjectId', type: 'Guid' },
        { name: 'bzObjMemberCode', type: 'Int' },
        { name: 'bzObjType', type: 'BzObjType' },
      ],
    },
    fieldDefinitions: fields,
  };
